import { BonusPoints } from '../../ui/BonusPoints';
import { Type, Money, EuroCents } from '@hugendubel/ws_client';

export class WsBonusShopHistoryTransaction {
    type: string;
    date: Date;
    points: BonusPoints;
    validUntil: Date | undefined;
    bonId: string | undefined;
    revenue: EuroCents | undefined;

    constructor(type: string, date: Date, points: BonusPoints, validUntil?: Date, bonId?: string, revenue?: EuroCents) {
        this.type = type;
        this.date = date;
        this.points = points;
        this.validUntil = validUntil;
        this.bonId = bonId;
        this.revenue = revenue;
    }

    static fromApi(json: any): WsBonusShopHistoryTransaction {
        const type = Type.string(json.type, 'BonusShopHistoryTransaction.type');
        const date = Type.dateString(json.date, 'BonusShopHistoryTransaction.date');
        const rawPoints = Type.number(json.points, 'BonusShopHistoryTransaction.points');
        const validUntil = Type.optional.dateString(json.validUntil, 'BonusShopHistoryTransaction.validUntil');
        const bonId = Type.falsyToUndefined.string(json.bonId, 'BonusShopHistoryTransaction.bonId');
        const revenueValue = Type.optional.number(json.revenue, 'BonusShopHistoryTransaction.revenue');
        const revenueMoney = revenueValue ? Money.parse(revenueValue) : undefined;

        return new WsBonusShopHistoryTransaction(
            type,
            date,
            new BonusPoints(rawPoints),
            validUntil,
            bonId,
            revenueMoney
        );
    }
}

export class WsBonusShopHistory {
    transactions: WsBonusShopHistoryTransaction[];

    constructor(transactions: Array<WsBonusShopHistoryTransaction>) {
        this.transactions = transactions;
    }

    static fromApi(json: any): WsBonusShopHistory {
        return new WsBonusShopHistory(
            Type.array(json.transactions, 'BonusShopHistory.transactions').map(WsBonusShopHistoryTransaction.fromApi)
        );
    }
}
